module.exports = __webpack_public_path__ + "static/flashcard_4-b3bdb4a6547edf0f3eb456343a29b06d.jpg";